export default __webpack_public_path__ + "static/gnarwall2-137197ad084c91c6e9aa8816c7cddb12.png";